import React, { useEffect, useMemo, useState } from "react";
import { collection, getDocs, doc, updateDoc } from "firebase/firestore";
import { db } from "../../Middleware/Firebase/firebase";
import "../../Css/Dashcrud.css";
import { useBusinessAuth } from "../../Middleware/context/BusinessContext";

export default function FormOrderProduct() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  // Supplier ID (comes from BusinessContext)
  const { companyProfile } = useBusinessAuth();
  const id = companyProfile.id;

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);

        const snap = await getDocs(collection(db, "orders"));
        const docs = snap.docs.map(d => ({ id: d.id, ...d.data() }));
        setOrders(docs);

      } catch (err) {
        console.error("Erro ao buscar pedidos:", err);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  // Filter items belonging to this supplier
  const ordersWithSupplierItems = useMemo(() => {
    return orders.map((order) => {
      const basketArray = Array.isArray(order?.items?.basket)
        ? order.items.basket
        : [];

      const supplierItems = basketArray.filter(
        (item) => item?.idSupplier === id
      );

      return {
        ...order,
        supplierItems,
      };
    });
  }, [orders, id]);


  // 👉 FUNCTION TO UPDATE ITEM STATUS
  const handleSell = async (orderId, itemIndex) => {
    try {
      const orderRef = doc(db, "orders", orderId);

      // Find order
      const order = orders.find(o => o.id === orderId);
      if (!order) return;

      const basket = [...order.items.basket];

      // Update only the selected item
     basket[itemIndex] = {
      ...basket[itemIndex],
       status: "Sold",

   

     };

      // Write back the modified basket
      await updateDoc(orderRef, {
        "items.basket": basket,
      });

      // Update UI state
      setOrders(prev =>
        prev.map(o =>
          o.id === orderId
           ? {
               ...o,
                items: {
                 ...o.items,
                  basket,
                },
              }
           : o
       )
     );

     alert("Venda concluída!");

   } 
    
    catch (err) {
     console.error("Erro ao atualizar status:", err);
      alert("Erro ao atualizar pedido.");
   }
  };


  const totalItemsThisSupplier = ordersWithSupplierItems.reduce(
    (acc, o) => acc + (o.supplierItems?.length || 0),
    0
  );

  if (loading) {
    return <div className="container">A carregar pedidos…</div>;
  }

  return (
    <div className="container">
      <h1>Pedidos deste fornecedor</h1>

      {totalItemsThisSupplier === 0 ? (
        <div className="empty-state">Não recebeste nenhum pedido.</div>
      ) : (
        <div className="grid">
          {ordersWithSupplierItems.map((order) => {
            if (!order.supplierItems || order.supplierItems.length === 0) {
              return null;
            }

            return (
              <div key={order.id} className="card">
                <h3>Cliente: {order.requester || "—"}</h3>

                {order.supplierItems.map((item, idx) => {
                  // Find actual index of item in basket to update correctly
                  const realIndex = order.items.basket.findIndex(
                    (b) => b.id === item.id
                  );

                  const isSold = item.status === "Sold";

                  return (
                    <div
                      key={`${order.id}-${item?.id || idx}`}
                      className="line-item"
                      style={{ margin: "8px 0", borderTop: "1px solid #eee", paddingTop: 8 }}
                    >
                      <p>Produto: {item?.nameProduto || item?.artigo || "—"}</p>
                      <p>Quantidade: {item?.quantity ?? "—"}</p>
                      <p>Tamanho: {item?.tamanho ?? "—"}</p>
                      <p>Cor: {item?.cor ?? "—"}</p>
                      <strong>Preço: {item?.price ?? "—"} {item?.currency ?? ""}</strong>

                      <div style={{ marginTop: 8 }}>
                        <button
                          className="button"
                          disabled={isSold}
                          style={{
                            backgroundColor: isSold ? "#aaa" : "#4CAF50",
                            cursor: isSold ? "not-allowed" : "pointer",
                          }}
                          onClick={() => handleSell(order.id, realIndex)}
                        >
                          {isSold ? "Vendido" : "Finalizar Venda"}
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}